module.exports = __webpack_public_path__ + "img/medal-exercise.9e15f740.svg";